import { AbstractError } from '@/domain/errors/abstract-error.js';

export class BadRequestError extends AbstractError {
    public readonly code = 400;
    constructor(message = 'Bad request', args?: string[]) {
        super(message, args);
    }
}
